import { createFileRoute } from '@tanstack/react-router'
import { ExportPortalPage } from '@/components/pages/ExportPortal'

export const Route = createFileRoute('/export')({
  component: ExportPortalPage,
})
